import React from 'react';
import styled from 'styled-components';
import SectionTitle from '@shopDetails/components/Shimmer/Title';
import ProductCardShimmer from '../ProductList/Layout/LayoutOne/components/ProductCardShimmer';
import SwimlaneShimmer from './SwimlaneShimmer';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;
  margin-top: ${({ theme }) => theme.spacing(10)};
  margin-bottom: ${({ theme }) => theme.spacing(200)};
`;

const shimmers = [1, 2, 3, 4, 5, 6];

function ShopDetailsShimmers() {
  return (
    <>
      <SwimlaneShimmer isDesktopLayout />
      <SectionTitle />
      <Container>
        {shimmers.map(v => (
          <ProductCardShimmer key={v} isDesktopLayout />
        ))}
      </Container>
    </>
  );
}

export default ShopDetailsShimmers;
